import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-24 bg-wine-dark text-cream px-6 relative overflow-hidden" data-id="element-268">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-269">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-amber rounded-full blur-3xl" data-id="element-270"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-wine-light rounded-full blur-3xl" data-id="element-271"></div>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-272">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-273">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-274">
            La solución es ridículamente simple <br data-id="element-275" />
            <span className="text-amber italic" data-id="element-276">(y por eso funciona)</span>
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-277">
            En vez de “grandes movimientos”, vas a usar dos herramientas
            diseñadas para eliminar el riesgo:
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-278">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-279">
            <div className="h-12 w-12 bg-amber rounded-full flex items-center justify-center mb-6 font-serif text-2xl font-bold text-wine-dark" data-id="element-280">
              1
            </div>
            <h3 className="text-2xl font-bold text-amber mb-4" data-id="element-281">
              Micro-Inicios
            </h3>
            <p className="text-cream/80 leading-relaxed" data-id="element-282">
              Acercamientos de 5 minutos que no activan pena ni defensas.
              Pequeños gestos que abren la puerta sin tirarla abajo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-283">
            <div className="h-12 w-12 bg-amber rounded-full flex items-center justify-center mb-6 font-serif text-2xl font-bold text-wine-dark" data-id="element-284">
              2
            </div>
            <h3 className="text-2xl font-bold text-amber mb-4" data-id="element-285">
              Semáforo de Comodidad
            </h3>
            <p className="text-cream/80 leading-relaxed mb-6" data-id="element-286">
              Una forma rápida de saber si hoy es verde, amarillo o rojo… sin
              drama.
            </p>

            {/* Visual Semáforo */}
            <div className="flex justify-center gap-4" data-id="element-287">
              <div className="flex flex-col items-center gap-2" data-id="element-288">
                <div className="w-8 h-8 rounded-full bg-green-500 shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-289"></div>
                <span className="text-xs text-cream/60" data-id="element-290">Verde</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-291">
                <div className="w-8 h-8 rounded-full bg-yellow-500 shadow-[0_0_15px_rgba(234,179,8,0.5)]" data-id="element-292"></div>
                <span className="text-xs text-cream/60" data-id="element-293">Amarillo</span>
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-294">
                <div className="w-8 h-8 rounded-full bg-red-500 shadow-[0_0_15px_rgba(239,68,68,0.5)]" data-id="element-295"></div>
                <span className="text-xs text-cream/60" data-id="element-296">Rojo</span>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="bg-amber/10 p-8 rounded-xl border border-amber/20 text-center" data-id="element-297">
          <p className="text-xl md:text-2xl font-serif italic text-cream" data-id="element-298">
            "Eso cambia todo por una razón:{' '}
            <strong className="text-amber not-italic" data-id="element-299">
              porque deja de ser adivinar
            </strong>
            . Ya no tienes que lanzarte al vacío. Solo tienes que iniciar
            chiquito… y respetar el ritmo."
          </p>
        </div>
      </div>
    </section>;
}